<template>
  <div class="offer_container">
      <Indicator v-if="textList.length > 0"  counter="03" :title="textList[3].title" :content="textList[3].content" />
      <!-- <Indicator counter="03" title="textList[3].title" content="textList[3].content" /> -->
        <div class="categories">
          <router-link tag="div" v-for="icon in icons" class="single_category" :key="icon.id" :style="`background-image: ${icon.style}, url(${icon.url})`" :to="icon.to">
            <h4 v-if="!icon.disabled">{{icon.name}}</h4>
            <h4 v-else>Chwilowo niedostępne</h4>
          </router-link>
        </div>
  </div>
</template>

<script>
import Indicator from '../components/Indicator.vue';
import { mapMutations, mapState } from 'vuex';
export default {
    name: 'Offer',
    components:{
        Indicator
    },
    computed:{
      ...mapState({
        icons: state=> state.offerIcons.offerIcons,
        textList: state=>state.texts.textList
      })
    },
    methods:{
      ...mapMutations(['bindOfferIcons'])
    },
    mounted(){
      // this if prevents multiple bind icons
      if(this.icons.length === 0){
        this.bindOfferIcons();
      }
    }
}
</script>

<style scoped lang="scss">
.categories{
  width: 100%;
  padding: 0 34px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 12px 0;
}
.single_category{
  width: 146px;
  height: 146px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  color: white;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  h4{
    padding: 12px;
  }
}
@media (max-width: 359px){
  .categories{
    padding: 0;
  }
  .single_category{
    width: 130px;
    height: 130px;
  }
}
</style>